var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"main-footer"},[_c('small',[_vm._v(_vm._s(_vm.$t('copyright')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }